<template>
	<dashboard-dropdown-section
		title="Requests Received"
		type="locum-booking-requests-received"
		:items-shown="5"
		:items="requests"
		event-name="load-locum-booking-requests"
		@load-locum-booking-requests="loadMore"
	/>
</template>

<script>
import { mapActions } from 'vuex';

import DashboardDropdownSection from '@/components/custom/DashboardDropdownSection';

export default {
	name: 'LocumBookingRequests',

	components: { DashboardDropdownSection },

	data: () => ({
		requests: [],
	}),

	methods: {
		...mapActions('availability', ['FetchProfessionalAvailability']),
		...mapActions('offers', ['FetchOffers']),

		async loadMore(event) {
			const { startDate, endDate } = event;

			const availabilityRequests = await this.FetchProfessionalAvailability({ startDate, endDate, availabilityType: 'availability-requests' });
			const filteredAvailabilityRequests = availabilityRequests.map(request => ({ ...request, event_start_date: request.offer_start_date }));

			const offersRequests = await this.FetchOffers({ startDate, endDate, offersType: 'locum-booking-requests-received' });
			const filteredOffersRequests = offersRequests.map(request => ({ ...request, event_start_date: request.offer_start_date }));

			this.requests = [...filteredAvailabilityRequests, ...filteredOffersRequests];
		},
	},
};
</script>
